import React from "react";

interface IconDashboardProps {
  width?: string;
  height?: string;
  fill?: string;
}

const IconDashboard: React.FC<IconDashboardProps> = ({
  width = "20px",
  height = "20px",
  fill = "#f7f5f5",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-layout-dashboard-icon lucide-layout-dashboard"
  >
    <rect width="7" height="9" x="3" y="3" rx="1" />
    <rect width="7" height="5" x="14" y="3" rx="1" />
    <rect width="7" height="9" x="14" y="12" rx="1" />
    <rect width="7" height="5" x="3" y="16" rx="1" />
  </svg>
);
export default IconDashboard;
